let cacheStorage = new Map();
let enableCookie = navigator.cookieEnabled;


const StorageManager = {
    check: () => {
        if (!enableCookie) {
            //Alert
        }
        console.log("cookie " + (enableCookie ? "enable" : "disable"))
    },
    getItem: (key) => {
        return enableCookie ?
            localStorage.getItem(key) :
            cacheStorage.get(key)
    },
    setItem: (key, value) => {
        return enableCookie ?
            localStorage.setItem(key, value) :
            cacheStorage.set(key, value)
    },
    removeItem: (key) => {
        return enableCookie ?
            localStorage.removeItem(key) :
            cacheStorage.delete(key)
    },
    isEnableCookie: () => {
        return enableCookie;
    }
}

export default StorageManager;